const PlaceHolderQs = [
  'What did you learn today?',
  'What have you enjoyed this week?',
  'Describe how you feel?',
  'What topics are you finding difficult at the moment?',
];

export default PlaceHolderQs;
